if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
 
(function(){

	//For accordion quad
	$('.accordion .accordion__content').hide();
	// $('.accordion .accordion__item:first').addClass("active").find(".accordion__content").slideDown();
	// $('.accordion .accordion__title:first').addClass("active");

	$('.accordion__title').click(function (e) {
		if ($(this).parent().hasClass('active')) {
			$(this).parent().removeClass('active')
			$(this).siblings('.accordion__content').slideUp()
			$(this).removeClass('active')
		} else {
			// $('.accordion__item.active .accordion__content').slideUp()
			// $('.accordion__item.active').removeClass('active')
			// $('.accordion__title').removeClass('active')

			$(this).parent().addClass('active')
			$(this).addClass('active').siblings('.accordion__content').slideDown()
		}
	})

	// PRELOAD
	if (document.getElementById('preload')) {
		document.body.classList.add('noscroll');
		document.getElementById('preload').classList.add('loading');
		setTimeout(() => {
			document.body.classList.remove('noscroll');
			document.getElementById('preload').classList.add('loaded');
		}, 4000);
	}

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

	$('.forgot').click(function () {
		$("#loginForm").addClass("hidden");
		$("#forgotForm").removeClass("hidden");
		$(".errorMsg").css( "display", "none" );
	});

	if(window.location.pathname.indexOf('/properties')>-1){
		//validationSession();
	}
})();
function validationSession(){
	console.log('Start validation Session');
	const rememberMe = localStorage.getItem('remember'),
		  username = localStorage.getItem('username');
	if(registerMembers==true && username.length>0){
		console.log('Exists session');
		
	}
	console.log('End validation Session');
}
function registerMembers(e){
	e.preventDefault();
	var extras = {},formId = "registerForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'registerForm',
		email: $("#email").val(),
		firstname: $("#firstname").val(),
		lastname: $("#lastname").val(),
		password: $("#password").val(),
        category: $("#category").val(),
		address: $('#address').val(),
		register_i_gree:$("#register_i_gree").is(":checked"),
		register_subscribe:$("#register_subscribe").is(":checked"),
		_token : $('#_token').val(),
		tr4pValidation:1,
		disabled_welcome_email:'1'
	},
	function(data){
		
		if(data.result == 'success') {
			//extras.page_redirect = '/';
			if( document.URL.indexOf( "friends-and-family-register" ) != "-1" )
				document.location = "/properties";

			showResult(data, formId, extras);

		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function loginMembers(e){
	e.preventDefault();
	var extras = {},formId = "loginForm";
	clearErrors(formId);
	formProcessSetup(formId);

	// if( $("#username").val() == "" && $("#password").val() == "" ){
	// 	$( ".errorMsg" ).html( "Please fill out all required fields" );
	// 	if(!$("#username").hasClass('error'))$("#username").addClass('error');
	// 	if(!$("#password").hasClass('error'))$("#password").addClass('error');
	// 	$( ".errorMsg" ).show();
	// }else{
	// 	$( ".errorMsg" ).html( "" );
	// 	$( ".errorMsg" ).show();
	// }

	// if( $("#username").val() == "" ){
	// 	if(!$("#username").hasClass('error'))$("#username").addClass('error');
	// 	$( ".username.error-msg" ).removeClass( "hidden" );
	// 	$( ".btnSubmit" ).show();
	// 	return;
	// }else{
	// 	$( ".username.error-msg" ).addClass( "hidden" );
	// }

	// if( $("#password").val() == "" ){
	// 	if(!$("#password").hasClass('error'))$("#password").addClass('error');
	// 	$( ".password.error-msg" ).removeClass( "hidden" );
	// 	$( ".btnSubmit" ).show();
	// 	return;
	// }else{
	// 	$( ".password.error-msg" ).addClass( "hidden" );
	// }

	$.post( "/ajax/functions.php",
	{
		operation: 'loginMembers',
		username: $("#username").val(),
		password: $("#password").val(),
        category: $("#category").val(),
		remember: $("#remember").is(":checked"),
	},
	function(data){
		if(data.result == 'success') {
			localStorage.setItem( "username", data.name );
			localStorage.setItem( "remember",  $("#remember").is(":checked"));

			extras.page_redirect = '/properties';
			document.location = "/properties";
			if(data.warning==1)
				localStorage.setItem('msg',1);
			//showResult(data, formId, extras);
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function activeAccount(e){
	e.preventDefault();
    var extras = new Object(),formId = 'activeForm',$processpage = 'ajax/functions.php';;
	extras.dont_hide_form = "1";
    extras.dont_reset_form = "1";

    $("#processing").show();
	$("#btnSubmit").hide();
	
	$('.errorMsg').slideUp();
    $(".errorMsg").html('');

    clearErrors(formId);
    formProcessSetup(formId);
    
    $.post(site_url+$processpage,
        { 
            operation: 'activeAccount', 
            email_reset: $("#email_reset").val(),
            token: $("#token").val(),
            password_reset: $('#password_reset').val(),
            confirm_password : $('#confirm_password').val()
        },function(data){
            if(data.result=='success'){
                //toastr.success('Thank you for your request.');
                $("#email_reset").val('');
                $('#password_reset').val('');
                $('#confirm_password').val('');
                $('#activeForm .errorMsg').slideDown();
				$(".errorMsg").html('Thank you. Your password has been reset. Please save this password for your records.');
				extras.page_redirect = "index.php";
				document.location = "/properties"
				setTimeout(()=>{
					showResult(data,formId,extras);
				},4000);
            }else{
                showErrors(data,formId,extras);
            }
            $("#processing").hide();
        },
        "json"
    );
	

}

function processRecovery(e){
	e.preventDefault();
	var extras = {},formId = "forgotForm";
	clearErrors(formId);
	formProcessSetup(formId);
	$.post( "/ajax/functions.php",
	{
		operation: 'processRecovery',
		email_forgot: $("#email_forgot").val()
	},
	function(data){
		if(data.result == 'success') {
			$("#forgotForm").addClass("hidden");
			$('.forgotForm__success').removeClass("hidden");
		}else{
			showErrors(data, formId, extras);
		}
	},
	"json"
	);
}

function showResult(data, formId, extras)
{
	/*extras parameters:
		dont_reset_form = if set will not reset the form
		dont_hide_form = if set will not hide the form
		skip_parent_errors = if set errors will not be placed on the parent elements
		step_content = if set will load up the content  into div
		page_redirect = if set will redirect to the page passed on success
		function_name = if set will call function on form submit success
		use_exact_path = if set will use exact path passed instead of a SITE_ROOT path
		exact_path = path to use for the above option
		dont_scroll_on_error = if set will not scroll to top of page when theres an error
		dont_scroll_on_success = if set will not scroll to top on success
		scrollto = element id to scroll to instead
		clear_errors = if set will clear errors on the form
		dont_hide_buttons = if set will not hide the buttons, use for nested forms.
	*/
	if(extras == undefined) { extras = '' } //check if the extras parameters array exists if not set it so that we dont get errors farther down

	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

	if(extras.dont_hide_buttons != '1')
	{
    	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  		if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
  	}

  	//check if result is being passed the new way
	var result; //will hold the value for our result success | error

	if(data[0]==undefined) result = data.result;
	else result = data[0].result;

  	if(result=="success")
	{
  		if(extras.dont_reset_form != '1') { resetForm(formId); } //if the dont_reset_form is isnt set then reset the form
		if(extras.step_content != undefined) //check if the ajax page parameter is defined
		{
			//alert('load up via ajax: ' + data[1].step_content);
		   	$("#step_content").hide();	//this has to stay the same because this is where the forms are being loaded into
	   		$("#step_content").load(SITE_ROOT+extras.step_content,function(){
	   			_gaq.push(['_trackPageview', extras.step_content]);

	        	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	        	$("#step_content").slideDown();}
	        );
	   		if(extras.dont_scroll_on_success != '1')
	        {
		   		if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
	        }
		}
		else if(extras.page_redirect != undefined) //check if page redirect parameter is passed
		{
			if(extras.use_exact_path =='1')
			{
				document.location = extras.exact_path;
			}
			else
			{
				document.location= extras.page_redirect;
			}
		}
		else if(extras.function_name != undefined)
		{
			eval(extras.function_name)();
		}
		else
		{
			$( ".thankyouMsg" ).html( data.data.message );
			if($('.thankyouMsg').length > 0) $('#'+formId+' .thankyouMsg').slideDown();
			if($('#'+formId).prev(".thankyouMsg").length > 0) $('#'+formId).prev(".thankyouMsg").slideDown();

			if(extras.dont_hide_form != '1')
			{
				if($('#'+formId).length > 0) $("#"+formId).slideUp();
			}
			else
			{
				if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+ ' .btnSubmit').show();
	        	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
			}
			if(extras.dont_scroll_on_success != '1')
	        {
				if(extras.scrollto != undefined)
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
		        	} else {
		        		$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
		        	}
		   		}
		   		else
		   		{
		   			if($('#fbcontent').length > 0) {
		        		$('#fancybox-inner').scrollTo(0,100);
		        	} else {
		        		$.scrollTo(0,800);
		        	}
		   		}
			}
		}
		if(extras.clear_errors == '1')
		{ 	clearErrors(formId);	}
	}
	else
	{
		showErrors(data,formId,extras);
	}

	
}

function showErrors(data,formId,extras){
	clearErrors(formId);

	var newData = new Object();
	if(data[0]==undefined) newData = data;
	else newData = data[0];

	//loop through the JSON array and display the errors
	$.each(newData, function(key,value) {
		if(key != "result"){
			if(extras.add_parent_error != undefined){ 
				if($('#'+key).parent().hasClass("form-entry")) $('#'+key).parent().addClass("error");
			}
			$('label[for='+key+']').addClass("error");
			$('#'+key).addClass("error");
			if($('label[for='+key+']').length>0)
				$( '<span id="'+key+'-error" class="msg error" >This field is required.</span>' ).insertAfter($('label[for='+key+']'));
			else
				$( '<span id="'+key+'-error" class="msg error" >This field is required.</span>' ).insertAfter($('#'+key));
		}
	});
	if($("#"+formId+" .errorMsg").html()=="") {
		//$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red above.</li></ul>");
		if(newData.errorLogin !== undefined && formId == 'loginForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorLogin+"</li></ul>");
			if(!$("#username").hasClass('error'))$("#username").addClass('error');
			if(!$("#password").hasClass('error'))$("#password").addClass('error');
		}else if(newData.errorActiveAccount !== undefined && formId == 'activeForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorActiveAccount+"</li></ul>");
			$('#confirm_password-error').remove();
		}else if(newData.errorProcessRecovery !== undefined && formId == 'forgotForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorProcessRecovery+"</li></ul>");
			if($('#email_forgot').val()!=='')
				$('#email_forgot-error').remove();
		}else if(newData.errorRegisterForm !== undefined && formId == 'registerForm'){
			$("#"+formId+" .errorMsg").html("<ul><li>"+newData.errorRegisterForm+"</li></ul>");
		}else if(formId !== 'loginForm' && formId !== 'activeForm' && formId !== 'forgotForm'){
			console.log(formId);
			$("#"+formId+" .errorMsg").html("<ul><li>Please correct the errors highlighted in red above.</li></ul>");
		}
			
	} else {
		$("#"+formId+" .errorMsg").html("<ul>"+$("#"+formId+" .errorMsg").html()+"</ul>");
	}
	$("#"+formId+" .errorMsg").slideDown();

	if(extras.dont_scroll_on_error != '1')
	{
		if(extras.scrollto != undefined)
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo('#'+extras.scrollto,100,{offset:{top:-20},axis:'y'});
        	} else {
        		//$.scrollTo('#'+extras.scrollto,800,{offset:{top:-20},axis:'y'});
        	}
   		}
   		else
   		{
   			if($('#fbcontent').length > 0) {
        		$('#fancybox-inner').scrollTo(0,100);
        	} else {
        		//$.scrollTo(0,800);
        	}
   		}
	}

	if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').hide();
	if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').show();
}


function clearErrors(formId)  //safari bug is here!!
{
	$('input[type="text"],input[type="password"],input[type="radio"],textarea,select').removeClass("error");
	$('#'+formId+' label').each(function(index){
        if(!$(this).hasClass('errorMsg')) $(this).removeClass("error");
    });

	$('#'+formId+' span').each(function(index){
        if($(this).hasClass('msg error'))$(this).remove();
    });
	
}

function resetForm(formId)
{
	//$('[type="text"]').val("");
	$('#'+formId+' textarea').val("");
	$(':input','#'+formId)
	 .not(':button, :submit, :reset, :hidden, :checkbox , :radio')
	 .val('')
	 .removeAttr('checked')
	 .removeAttr('selected');

	clearErrors(formId);
}
function formProcessSetup(formId)
{
	$('#'+formId+' .errorMsg').slideUp();
	$('#'+formId+' .errorMsg').html('');

    if($('#'+formId+' .processing').length > 0) $('#'+formId+' .processing').show();
  	//if($('#'+formId+' .btnSubmit').length > 0) $('#'+formId+' .btnSubmit').hide();
}